export function NextButton() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="31" stroke="white" strokeWidth="2" />
      <g clipPath="url(#clip0_1073_710)">
        <path d="M38.6834 30.3333H18.6667V33.6666H38.6834V38.6666L45.3334 32L38.6834 25.3333V30.3333Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_1073_710">
          <rect width="40" height="40" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  )
}
